import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';

const CharacterBiographyEditor = ({ data, saveBiography, showEditor = false, handleClose }) => {
    let workingText = '';
    const [characterBiography, setCharacterBiography] = useState(undefined);
    const [error, setError] = useState(undefined);

    const handleSave = () => {
        saveBiography(characterBiography);
    }

    useEffect(() => {
        if (data === undefined)
            setCharacterBiography(undefined)
        else {
            setCharacterBiography(data.biography);
        }
    }, [data]);

    const updateText = (text) => {
        setCharacterBiography(text);
    }

    // console.log('[CharacterBiographyEditor] Display Modal Editor', showEditor);

    if (characterBiography === undefined) {
        return null;
    }

    return (
        <Modal size="lg" centered show={showEditor} >
            <Modal.Header>
                <Modal.Title>Editing Character Biography</Modal.Title>
            </Modal.Header>
            <Modal.Body>

                <textarea rows="20" className="form-control"
                    value={characterBiography}
                    onChange={(e) => updateText(e.currentTarget.value)} />
            </Modal.Body>
            <Modal.Footer>
                <span className="error"><font color="red">{error}</font></span>
                <Button variant="secondary" onClick={handleSave}>
                    Save
                </Button>
                <Button variant="secondary" onClick={handleClose}>
                    Cancel
                </Button>
            </Modal.Footer>
        </Modal>

    );

}

export default CharacterBiographyEditor;